import React from 'react';

import { Title } from '@mantine/core';
import Drawer from 'components/Drawer';

import AddPaymentMethod from './AddPaymentMethod';

interface AddPaymentMethodDrawerProps {
  athleteId: string;
  gymId: string;
  opened: boolean;
  closeHandler: () => void;
  /** Forwarded to AddPaymentMethod: the drawer is shared verbatim with the athlete Account page. */
  isStaffContext?: boolean;
}

const AddPaymentMethodDrawer = ({
  athleteId,
  gymId,
  opened,
  closeHandler,
  isStaffContext,
}: AddPaymentMethodDrawerProps): JSX.Element => {
  return (
    <Drawer
      closeOnClickOutside
      title={<Title order={3}>Add Payment Method</Title>}
      opened={opened}
      onClose={closeHandler}
      size='lg'
    >
      <AddPaymentMethod
        athleteId={athleteId}
        gymId={gymId}
        isStaffContext={isStaffContext}
        successHandler={closeHandler}
        cancelHandler={closeHandler}
      />
    </Drawer>
  );
};

export default AddPaymentMethodDrawer;
